import React, { memo } from "react";
import { HappycoWorkOrderFragment } from "gql/graphql";
import colors from "app/colors";
import { Text, VStack } from "@chakra-ui/react";
import moment from "moment";
import { COMMON_DATE_CALENDAR_FORMATS } from "modules/utils/Constants";

interface IProps {
  happycoWorkOrder: HappycoWorkOrderFragment;
}

const HappycoWorkOrderScheduledTime = ({ happycoWorkOrder }: IProps) => (
  <VStack spacing={0} alignItems="flex-start">
    <Text fontSize={12} fontWeight={500} color={colors.gray50}>
      Scheduled
    </Text>
    {happycoWorkOrder.scheduleTime ? (
      <Text fontSize={14} fontWeight={700} color={colors.blackSecondary}>
        {moment(happycoWorkOrder.scheduleTime).calendar(
          COMMON_DATE_CALENDAR_FORMATS,
        )}{" "}
      </Text>
    ) : (
      <Text
        fontSize={14}
        fontWeight={500}
        color={colors.blackSecondary}
        fontStyle="italic"
      >
        Unscheduled
      </Text>
    )}
  </VStack>
);

export default memo(HappycoWorkOrderScheduledTime);
